import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import AreaCode from '@App/kit/fields/v2/PhoneNumberForm/AreaCode'
import LineNumber from '@App/kit/fields/v2/PhoneNumberForm/LineNumber'
import { StoresContext } from '@App/contexts'
import { FormFields, FormFieldType, isFormFieldProp } from '@App/forms/v2/common/form-field'
import { PhoneNumberType } from '@Entities/schemas/common/phone-number-schema'
import RootStore from '@App/stores/root-store'
import DropdownForm from '@App/kit/fields/v2/DropdownForm'
import DropdownFormFieldProps from '@App/forms/v2/common/dropdown-form-field'
import { observer } from 'mobx-react'

interface PhoneNumberFormProps {
    phoneNumberFormFields: FormFieldType<PhoneNumberType>
}

const PhoneNumberForm = (props: PhoneNumberFormProps) => {
    const { libStore } = useContext<RootStore>(StoresContext)
    const phoneNumberFormFields: FormFields<PhoneNumberType> =
        props.phoneNumberFormFields as FormFields<PhoneNumberType>
    const [phoneCountryCode, setPhoneCountryCode] = useState<DropdownFormFieldProps>(
        phoneNumberFormFields.phoneCountryCode as DropdownFormFieldProps
    )

    const setPhoneCountryCodeOptions = () => {
        setPhoneCountryCode({
            ...phoneCountryCode,
            options: libStore.phoneCountryCodes,
        })
    }

    useEffect(() => {
        setPhoneCountryCodeOptions()
    }, [])

    return (
        <div className="phone-number-form-component">
            <label className="small main-phone-label">Phone Number</label>
            <div className="phone-inputs-block">
                <div className="phone-country-code">
                    <DropdownForm {...phoneCountryCode} />
                </div>
                {phoneNumberFormFields.phoneAreaCode && isFormFieldProp(phoneNumberFormFields.phoneAreaCode) && (
                    <AreaCode {...phoneNumberFormFields.phoneAreaCode} />
                )}
                {isFormFieldProp(phoneNumberFormFields.phoneNumber) && (
                    <LineNumber {...phoneNumberFormFields.phoneNumber} />
                )}
            </div>
        </div>
    )
}

export default observer(PhoneNumberForm)
